export const setupHintedInputs = (): void => {
  const hintedInputs = document.querySelectorAll('.hinted-input');

  hintedInputs.forEach((hintedInput) => {
    const input = hintedInput.querySelector('input') as HTMLInputElement;
    const label = hintedInput.querySelector('label.hint') as HTMLLabelElement;

    if (input.value && String(input.value).length > 0) {
      input.classList.add('hint');
    }

    input.addEventListener('focus', () => {
      input.classList.add('hint');
    });

    input.addEventListener('blur', () => {
      if (String(input.value).length <= 0) {
        input.classList.remove('hint');
      }
    });

    label.addEventListener('click', () => {
      input.focus();
    });
  });
};
